'use strict';
var GoogleMaps, base;

GoogleMaps = require('./google_maps');

if ((base = window.Groupon).Utils == null) {
  base.Utils = {};
}

window.Groupon.Utils.GoogleMaps = GoogleMaps;

